import React from 'react';

const arrowHeadIcon = () => (
  <svg viewBox="0 0 54.19 60" >
    <polygon points="0,0 54.19,30 0,60 	"/>
  </svg>
)

export default arrowHeadIcon;